interface FilterSpec {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
}

export function FilterBar({
  q,
  onQ,
  placeholder,
  filters = [],
}: {
  q: string;
  onQ: (value: string) => void;
  placeholder: string;
  filters?: FilterSpec[];
}) {
  return (
    <div className="flex flex-wrap items-center gap-2.5 border-b border-border p-4">
      <div className="relative min-w-0 flex-1 sm:max-w-xs">
        <span className="absolute top-1/2 left-3 -translate-y-1/2 text-ink-muted" aria-hidden>
          🔎
        </span>
        <input
          value={q}
          onChange={(e) => onQ(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          className="min-h-11 w-full rounded-full border border-border bg-surface pr-4 pl-9 text-[15px] sm:min-h-10"
        />
      </div>

      {filters.map((f) => (
        <label key={f.label}>
          <span className="sr-only">{f.label}</span>
          <select
            value={f.value}
            onChange={(e) => f.onChange(e.target.value)}
            className="min-h-11 rounded-full border border-border bg-surface px-4 pr-8 text-sm text-ink sm:min-h-10"
          >
            {f.options.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </label>
      ))}
    </div>
  );
}
